// export const utcToIst = (utcDate: string | Date) => {
//   if (!utcDate) return "";

//   return new Date(utcDate).toLocaleString("en-IN", {
//     timeZone: "Asia/Kolkata",
//   });
// };

/**
 * Converts a UTC date/string to IST display string (DD-MM-YYYY HH:mm:ss).
 * Used for showing table data in IST.
 */
export const utcToIst = (utcDate: string | Date) => {
  if (!utcDate) return "";

  const date = new Date(utcDate);

  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  const parts = formatter.formatToParts(date);
  const get = (type: string) => parts.find(p => p.type === type)?.value;

  return `${get("day")}-${get("month")}-${get("year")} ${get("hour")}:${get("minute")}:${get("second")}`;
};

/**
 * Converts a date-picker Date (local IST) to a UTC ISO string for API filtering.
 * isEnd=false → start of day in IST (00:00:00 IST) → UTC
 * isEnd=true  → end of day in IST (23:59:59.999 IST) → UTC
 *
 * IST = UTC+5:30, so:
 *   IST 00:00:00 = UTC 18:30:00 (prev day)
 *   IST 23:59:59 = UTC 18:29:59 (same day)
 */
export const formatDateUtc= (
  date: Date,
  isEnd: boolean = false
): string | null => {
  if (!date) return null;

  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  if (isEnd) {
    return new Date(year, month, day, 23, 59, 59, 999).toISOString();
  } else {
    return new Date(year, month, day, 0, 0, 0, 0).toISOString();
  }
};